import { withKeycloak } from "@react-keycloak/web";
import React from "react";
import { labels } from "../../../../../localization/labels";
import { activeFilter } from "../../../../../services/FilteringUtils";
import IndividualService from "../../../../../services/IndividualService";
import PartyRoleService from "../../../../../services/PartyRoleService";
import PathUtil from "../../../../../utils/PathUtil";
import TableUtils from "../../../../core/Table/TableUtils";
import { paths } from "../../../../paths";
import TableComponentWithDialog from "../../../page/TableComponentWithDialog";
import IndividualDetail from "./IndividualDetail";
import {
  individualValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";

class IndividualDetailContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.individualService = new IndividualService(this.keycloak);
    this.partyRoleService = new PartyRoleService(this.keycloak);

    this.state = {
      ...this.state,
      activeFilters: activeFilter,
      disabled: true,
      isNew: false
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.id = this.resolveItemId();
    if (this.id) {
      this.loadIndividual(this.id);
    } else {
      this.setComponentTitle(labels.individual);
    }
  }

  getComponentTitle = () => {
    return this.state.newEntity?.name;
  };

  loadIndividual = id => {
    this.prepareCall(
      this.individualService.getEntityById(
        id,
        this.onIndividualLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onIndividualLoad = data => {
    this.setState({ newEntity: data, disabled: false });
    this.setComponentTitle(data.name, true);
    this.loadData(this.state.pageInfo);
  };

  possibleSizesPerPage() {
    return [5, 10, 15];
  }

  onDeleteData = entity => {
    this.prepareCall(
      this.partyRoleService.deleteEntity(
        entity,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRowClick = (_, row) => {
    const itemPath = PathUtil.adminItemsPath(
      {
        path: paths.INDIVIDUALS,
        partyId: this.state.newEntity.id
      },
      {
        path: paths.PARTYROLES,
        id: row.id
      }
    );
    this.changePath(itemPath, row.name);
  };

  handleAddNew = () => {
    const itemPath = PathUtil.adminItemsPath(
      {
        path: paths.INDIVIDUALS,
        partyId: this.state.newEntity.id
      },
      {
        path: paths.PARTYROLES
      }
    );
    this.changePath(itemPath, labels.partyRole);
  };

  selectRow = {
    mode: "checkbox",
    selectColumnStyle: {
      textAlign: "center"
    },
    headerColumnStyle: {
      textAlign: "center"
    }
  };

  loadData = pageInfo => {
    pageInfo = {
      ...pageInfo,
      filters: this.state.activeFilters
    };

    if (this.state.newEntity?._links) {
      const url = this.state.newEntity._links.partyRoles.href;

      this.prepareCall(
        this.partyRoleService.getEntitiesWithParams(
          url,
          pageInfo,
          this.sortInfo,
          this.onDataLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalDataDateFrom);
  };

  updateData = individual => {
    this.prepareCall(
      this.individualService.putEntity(
        individual,
        this.onDataSaveResponse,
        this.messageHandler.handleError,
        this.onSaveSuccessMessage
      )
    );
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header",
      sort: true,
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "partyRoleTypeName",
      text: labels.roleType,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  render() {
    return (
      <IndividualDetail
        {...this.renderProps()}
        individual={this.state.newEntity}
        history={this.props.history}
        handleAddNew={this.handleAddNew}
        validationRules={validationRules.generalDataDateFrom}
        disabled={this.state.disabled}
      />
    );
  }
}

export default withKeycloak(IndividualDetailContainer);
